module.exports = __webpack_public_path__ + "img/test.66cdd008.svg";